//  font renamed as cardiuma-M - 23-08-24 - Dev Srini

const styles = theme => ({
    dashboardText2: {
        color: 'var(--b, #FFF) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '34px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },
    kycFilterfield: {
        display: 'flex',
        // marginLeft: '10px',
        marginBottom: '10px',
    },
    checkBoxNew: {
        color: "#fff ! important",
        '& .MuiCheckbox-root': {
            color: '#fff ! important'
        },
    },

    todo_list: {
        color: 'var(--b, #CEFEB8) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },

    indicator: {
        backgroundColor: '#F3D45E ! important',
    },

    pending_heading: {
        color: 'var(--b, #FFF) ! important',
        // fontFeatureSettings: 'clig' off  'liga' off,
        textTransform: 'none !important',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal ! important',
        fontWeight: '600 ! important',
        lineHeight: 'normal ! important',
    },

    pending_heading2: {
        color: ' var(--b, #FFF)! important',
        // width: '125px ! important',
        textAlign: 'center ! important',
        //font-feature-settings: 'clig' off, 'liga' off
        textTransform: 'none !important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '16px ! important',
        fontStyle: 'normal ! important',
        fontWeight: '400 ! important',
        lineHeight: 'normal ! important',
        marginLeft: '3% ! important'
    },
    horizantalTablayout: {
        width: '99% !important',
        borderRadius: '15px !important',
        background: '#131E2E !important',

    },
    customDataGrid: {

        '& .MuiDataGrid-columnHeaders': {
            color: '#747474 !important',
            fontFamily: 'cardiuma-M ! important',
            fontSize: '13px ! important',
            fontWeight: '600 ! important',
            lineHeight: '18px ! important'
        },

        '& .MuiDataGrid-cell': {
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '12px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
            borderBottom: '1.5px solid black ! important',
        },

        "& .MuiDataGrid-menuIconButton": {
            opacity: 1,
            color: "#fff ! important"
        },

        "& .MuiDataGrid-sortIcon": {
            opacity: 1,
            color: "#fff ! important",
        },

        '& .MuiDataGrid-withBorderColor': {
            borderColor: "none !important"
        },
        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select, & .MuiTablePagination-actions': {
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '13px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
        },

        '& .MuiSelect-icon': {
            color: '#fff ! important',
        },

        '& .MuiDataGrid-footerContainer': {
            border: 'none ! important',
        },

        '& .MuiDataGrid-overlay': {
            backgroundColor: '#131E2E ! important',
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '14px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
        },

        '& .MuiSvgIcon-root': {
            color: '#fff ! important',
        },

        '& .MuiDataGrid-filterIcon': {
            color: '#fff ! important',
        }

    },

    campaign_heading: {
        color: ' var(--b, #FFF) ! important',
        width: '125px ! important',
        textTransform: 'none !important',
        textAlign: 'center ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal ! important',
        fontWeight: '400 ! important',
        lineHeight: '18px ! important'
    },

    tableHeading: {
        minWidth: '100px',
        width: 'auto ',
        color: 'var(--b, #747474) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '18px ! important',
        whiteSpace: 'nowrap'
    },

    rowtext: {
        color: 'var(--b, #FFF)  ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px  ! important',
        fontStyle: 'normal',
        fontWeight: '400  ! important',
        lineHeight: '18px  ! important'
    },

    soundtest_heading: {
        color: 'var(--CTA, #F74542)',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '18px',
        textDecorationLine: 'underline'
    },

    modalcard: {
        width: '736px',
        height: '324px',
        flexShrink: 0,
        borderRadius: '14px',
        background: 'var(--b, #FFF)',
    },

    modalheading: {
        color: '#000',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '24px ! important',
        fontStyle: 'normal',
        fontWeight: '600 ! important',
        lineHeight: '18px ! important',
    },

    voicelayout: {
        width: '672px',
        height: '105px',
        flexShrink: 0,
        borderRadius: '12px',
        border: '1px solid #DFE0EB',
        background: 'var(--b, #FFF)',
    },

    inputColor: {
        color: '#000000 !important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontWeight: 500
    },

    select: {
        color: '#000000 ',
        width: '160px ',
        fontFamily: 'cardiuma-regular ',
   
    },

    intSelText: {
        color: '#000000 !important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontWeight: 500
    },
   

    pagination: {
        '& .MuiTablePagination-select': { color: '#fff' }, // Style select dropdown text color
        '& .MuiTablePagination-toolbar': { color: 'white' }, // Style toolbar text color
        '& .MuiTablePagination-caption': { color: 'white' }, // Style caption text color
        '& .MuiTablePagination-actions': { color: 'white' }, // Style pagination actions color,
        '& .MuiSvgIcon-root.MuiTablePagination-selectIcon': {
            color: 'white', // Apply color to the select icon
        },
    },

    
fnoFormDateField: {
    display: 'flex',
    marginTop: '25px',
    marginRight: '20px',
    marginBottom: '10px'
},

datePickerWrapper: {
    marginLeft: '10px'
},

datePicker: {
    width: '190px',
    backgroundColor: '#131E2E ! important',

    '& .MuiInputBase-root': {
        color: '#fff ! important',
        height: '40px',
        padding: '6px 10px',
    },
    '& .MuiInputLabel-root': {
        color: '#fff ! important',
        fontFamily: 'cardiuma-regular',
        fontSize: '14px',
        fontStyle: 'normal',
    },
    '& .MuiSvgIcon-root': {
        color: '#fff ! important',
    },

    "@media only screen and (max-width: 1620px)": {
        width: '190px !important'
    },
    "@media only screen and (max-width: 1420px)": {
        width: '180px !important'
    },
    "@media only screen and (max-width: 1350px)": {
        width: '170px !important'
    },
},

inputColor: {
    color: '#ffffff !important',
    fontFamily: 'cardiuma-regular ! important',
    fontSize: '14px ! important',
    fontWeight: 500
},

select: {
    color: '#ffffff !important',
    width: '160px !important',
    fontFamily: 'cardiuma-regular ! important',
    background: '#131E2E',
},

intSelText: {
    color: '#000 !important',
    fontFamily: 'cardiuma-M ! important',
    fontSize: '14px ! important',
    fontWeight: 500
},

})

export default styles
